import axios from "axios";

import { isSafeRedirectUrl } from "./utils/safeRedirect";

export function setupAxios() {
  axios.defaults.withCredentials = true;
  axios.defaults.baseURL = import.meta.env.BASE_URL ?? "";

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const location = error.response?.data?.location;
      if (typeof location === "string" && isSafeRedirectUrl(location)) {
        globalThis.location.assign(location);
      }
      return Promise.reject(error);
    },
  );
}
